import dataConstants from '../constants';

export { default as byLookup } from './byLookup';
export { default as byQRCode } from './byQRCode';
export { default as selectMatchingCardholder } from './selectMatchingCardholder';

export function requestManualLookup(surname, initial, dob, cardNumber) {
    return { type: dataConstants.MANUAL_LOOKUP_REQUESTED, surname, initial, dob, cardNumber };
}

export function receiveManualLookup(match) {
    return { type: dataConstants.MANUAL_LOOKUP_SUCCESS, match };
}

export function requestManualLookupFailed(error) {
    return { type: dataConstants.MANUAL_LOOKUP_FAILURE, error };
}

export function hideManualLookupDialog() {
    return { type: dataConstants.HIDE_MANUAL_LOOKUP_DIALOG };
}

export function showManualLookupDialog(context) {
    return { type: dataConstants.SHOW_MANUAL_LOOKUP_DIALOG, context };
}

export function showMultipleMatchesDialog(matches, context) {
    return { type: dataConstants.SHOW_MULTIPLE_MATCHES_DIALOG, matches, context };
}

export function hideMultipleMatchesDialog() {
    return { type: dataConstants.HIDE_MULTIPLE_MATCHES_DIALOG };
}
